<div class="controls">
  <wr-sensor-unit-select [(ngModel)]="sensorUnit" [disabled]="isDisabled"></wr-sensor-unit-select>
  <wr-label-select [(ngModel)]="label" [disabled]="isDisabled"></wr-label-select>
</div>
